import { render, staticRenderFns } from "./StoreDocItem.vue?vue&type=template&id=23a61c10&scoped=true"
import script from "./StoreDocItem.vue?vue&type=script&lang=js"
export * from "./StoreDocItem.vue?vue&type=script&lang=js"
import style0 from "./StoreDocItem.vue?vue&type=style&index=0&id=23a61c10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a61c10",
  null
  
)

export default component.exports